import { t } from '../i18n';

export const EXPORT_ISSUE_LABELS: Record<string, string> = {
  no_bank_account: t('invoices.export.issues.no_bank_account'),
  invalid_iban: t('invoices.export.issues.invalid_iban'),
  no_amount: t('invoices.export.issues.no_amount'),
  no_contractor_name: t('invoices.export.issues.no_contractor_name'),
  mpp_no_nip: t('invoices.export.issues.mpp_no_nip'),
  mpp_no_vat: t('invoices.export.issues.mpp_no_vat'),
  non_transfer: t('invoices.export.issues.non_transfer'),
  already_paid: t('invoices.export.issues.already_paid'),
  already_exported: t('invoices.export.issues.already_exported'),
  invalid_date: t('invoices.export.issues.invalid_date'),
  missing_swift_bic: 'Missing SWIFT/BIC for foreign transfer',
  sepa_not_eur: 'SEPA requires EUR currency',
  no_matching_debtor: 'No company account for this currency',
  missing_creditor_address: 'Missing creditor city/country for international transfer',
  swift_needs_bic: t('invoices.export.issues.swift_needs_bic'),
  missing_creditor_city: t('invoices.export.issues.missing_creditor_city'),
  missing_creditor_country: t('invoices.export.issues.missing_creditor_country'),
  mpp_intl_conflict: t('invoices.export.issues.mpp_intl_conflict'),
  non_iban_account: t('invoices.export.issues.non_iban_account'),
  not_vat_payer: t('invoices.export.issues.not_vat_payer'),
  invalid_country_format: t('invoices.export.issues.invalid_country_format'),
  no_debtor_account_for_currency: t('invoices.export.issues.no_debtor_account_for_currency'),
};

/** Issues that are informational, not actionable warnings */
export const TERMINAL_EXPORT_ISSUES = ['already_paid', 'already_exported', 'non_transfer'];
